import Plyr from 'plyr-js';
import 'plyr/dist/plyr.css';

export function initHeroPlyr() {
	const el = document.querySelector('#hero-player');
	if (!el) {
		console.warn('⚠️ Élément #hero-player introuvable');
		return null;
	}

	console.log('✅ Plyr initialisé sur #hero-player');

	const player = new Plyr(el, {
		controls: [],
		muted: true,
		autoplay: true,
		ratio: '16:9',
		vimeo: {
			autoplay: true,
			controls: false,
			muted: true,
			byline: false,
			portrait: false,
			title: false,
			speed: false,
			transparent: false,
			pip: false
		},
	});

	el.loop = true; // Active la lecture en boucle

	return player;
}

// Sélectionne tous les éléments déclencheurs
const launchers = document.querySelectorAll('[data-launcher]');
const playersMap = new Map(); // Map pour associer chaque dialog à son player Plyr

// Initialisation des players Plyr
const dialogVideos = document.querySelectorAll('.dialog-video');
dialogVideos.forEach((dialogVideo) => {
	const videoItem = dialogVideo.querySelector('.dialog-video__item');
	if (videoItem) {
		const player = new Plyr(videoItem, {
			fullscreen: { enabled: true, fallback: true, iosNative: true },
			// controls: [
			// 	'play-large',
			// 	'play',
			// 	'progress',
			// 	'current-time',
			// 	'mute',
			// 	'volume',
			// 	'settings',
			// 	'fullscreen'
			// ],
			ratio: '16:9',
			vimeo: {
				byline: false,
				portrait: false,
				title: false,
				speed: false,
				transparent: false
			},
		});
		// Associer le player à son dialog
		playersMap.set(dialogVideo, player);
	}
});

// Boucle sur chaque déclencheur
launchers.forEach(launcher => {
	launcher.addEventListener('click', () => {
		const videoId = launcher.getAttribute('data-launcher');
		const targetDialog = document.querySelector(`dialog[data-video="${videoId}"]`);

		if (targetDialog) {
			if (typeof targetDialog.showModal === 'function') {
				targetDialog.showModal();
			} else {
				console.warn('Le navigateur ne supporte pas <dialog>.');
			}
		} else {
			console.log(`Aucun <dialog> trouvé avec data-video="${videoId}"`);
		}
	});
});

// Sélectionne tous les boutons de fermeture
const closeButtons = document.querySelectorAll('.dialog-video__close');
closeButtons.forEach(button => {
	button.addEventListener('click', () => {
		const dialog = button.closest('dialog');
		if (dialog) {
			dialog.close();

			// Stopper la vidéo associée
			const player = playersMap.get(dialog);
			if (player) {
				player.stop(); // stop() remet la vidéo à 0, pause() si on veut mettre en pause
			}
		}
	});
});
